import { loginApis, baseUrlApis, appStoreCloudApis, platformApis, cookies } from "Api/index";
import {store} from "Store/store.index";
import { browserService, userBehaviorTrackingService } from "./index";
import {BROWSER_REMOVE_TICKET , USER_SIGN_IN_SUCCESS, GET_IS_EDU_SUCCESS, USER_SIGN_IN_FAILED, BROWSER_REMOVE_FOR_SSO} from "../constants";
import {
    SIGN_IN_SUCCESS,
    SIGN_IN_FAILED
} from "Components/viewer/ui/constants/event.constants";
import { storageGetItem, storageRemoveItem, storageSetItem, isJPDomain, isCommonFeatureDomain, getQueryVariable } from "@/utils/utils";

class UserService{
    constructor() {
        this.isHideNotifyErrors = false
    }
    updateHideNotifyErrors(value) {
        this.isHideNotifyErrors = value
    }
    resetHideNotifyErrors() {
        this.isHideNotifyErrors = false
    }
    /**
     * auto check ticket is from new window or current url.
     * 1. getTokenByTicket
     * 2. check token
     * 3. get user info
     * @param enterpriseId can be empty string
     * @param remember_me can be empty string
     * @param role can be empty string
     *
     * @memberof UserService
     * @returns {ret, token}
     */
    getUserInfoByTicket = async (ticket, enterpriseId, remember_me, role, fromTeamsToken = null, casService = '') => {
        //
        let useNewWindow = true;
        if(!ticket){
            ticket = baseUrlApis.getQueryVariable("ticket");
            useNewWindow = false;
        }
        if(!ticket){
            return {ret:0, token:""};
        }
        let keepCookie = remember_me == 1 || remember_me === true;
        if(!keepCookie){
          keepCookie = this.getRememberMe(ticket, keepCookie);
        }

        let result = {ret: 110001, token:""};
        try {
            let token;
            // use token directly on teams, sign by `ms_teams_integration`
            if (fromTeamsToken) {
                token = fromTeamsToken;
            } else {
                casService = casService || loginApis.getServiceByCWSTicket(useNewWindow);
                token = await loginApis.getTokenByTicket(ticket, casService);
            }
            if(token){
                result = await this.checkTokenAndInitUserInfo(token, enterpriseId, role, keepCookie);
                if(result.ret === 0){
                    this.checkRememberMe(keepCookie);
                }
            }
        } catch (error) {
            console.error("TCL: UserService -> getTokenByTicket -> error", error);
            if(error &&error.ret === 300017){
                result = error;
            }

        }

        const isSSO = getQueryVariable('isSSO')

        if (isSSO === 'true') {
            browserService.doSwitchViewPageBy(BROWSER_REMOVE_FOR_SSO);
        } else {
            // update location to remove ticket
            browserService.doSwitchViewPageBy(BROWSER_REMOVE_TICKET);
        }
        this.onCheckUserDetail(result);
        if(result.ret !== 0) store.appStore.doNoticeMessage(USER_SIGN_IN_FAILED);

        return result;

    }

    onCheckUserEmailType = ()=>{
        if (store.appStore.isOnPremiseDeployMode) return Promise.resolve();

        return appStoreCloudApis.doCheckEdu().then((isEdu) => {

            store.userStore.setEdu(isEdu);
            // edu 企业管理员不需要从这里更新权限。普通edu用户，会通过普通用户权限接口更新
            // isEdu && store.accountStore.updateSubscribeState(null);
            store.appStore.doNoticeMessage(GET_IS_EDU_SUCCESS);
        });
    }
    onCheckUserDetail = (result)=>{
        if(result.ret !== 0){
            // TODO: invalid ticket ret: 300017, to show dialog to user
            // if get token failed, need to clean cas cache.
            //store.userStore.loginOut();
            userBehaviorTrackingService.doSendGAEventByUserEvent(SIGN_IN_FAILED, "", ()=>{
                setTimeout(()=>{
                    store.userStore.loginOut(true);
                }, 200);
            });
            return;
        }
        // login in success
        // this.onCheckUserEmailType();
        // ga
        userBehaviorTrackingService.doSendGAEventByUserEvent(SIGN_IN_SUCCESS, "");
    }

    doCheckLogInAgain = (pathname) =>{
        // teams do not auto login in
        if(store.teamsAppStore.inTeamsApp){
          return false;
        }
        const docidForOffice = getQueryVariable('docidForOffice')
        const state = baseUrlApis.getQueryVariable("state");
        const vTest = baseUrlApis.getQueryVariable("test");
        const reviewSessionID = getQueryVariable('reviewSessionID')
        const fileLink = getQueryVariable('docUrl')
        const fileName = getQueryVariable('fileName')
        const oneDriveState = getQueryVariable('oneDriveState')
        const stateParam = oneDriveState && JSON.parse(oneDriveState)

        // file handler open 功能不用登录
        if(stateParam && stateParam.action === 'open') {
            return
        }
        if(reviewSessionID && fileLink && fileName){
            return false
        }
        // GSuite
        if (docidForOffice || (state && !isCommonFeatureDomain()) || vTest === 'performance') {
            return false;
        }

        const isLoginOut = storageGetItem(localStorage, 'isLoginOut')

        // 日本、loginOut保持原有逻辑 ONLINERD-5122
        if (isJPDomain() || isLoginOut) {
            let isRememberMe =  storageGetItem(localStorage, "remember-me");
            storageRemoveItem(localStorage, 'isLoginOut')
            if(!isRememberMe){
                return browserService.isNeedAutoSignIn(pathname);
                //return false;
            }
        }

        if(browserService.isAvoidAutoSignIn(pathname)) return false;
        // go to cas, to get ticket
        storageRemoveItem(localStorage, "remember-me");
        return true;
    }
    getRoleInfoFromLocal(token) {
        let val = storageGetItem(localStorage, "role") || cookies.get('role');

        if (!val || val === 'null' || val === 'undefined') {
            return '';
        }

        let value = typeof val === 'string' ? JSON.parse(val) : val
        const roleInfo = value[token];

        return roleInfo
    }
    // pre-load
    getEnterpriseId = (token, enterpriseId) =>{
      if(!enterpriseId)
          enterpriseId = baseUrlApis.getQueryVariable("enterpriseId");
      if (enterpriseId)
        return enterpriseId;
      if (token) {
        const info = this.getRoleInfoFromLocal(token)
        
        if (!info) {
          return '';
        }
        if (info.enterpriseId)
          return info.enterpriseId;
      }

      return '';
    }

    checkRole = (token, enterpriseId, role) =>{
        //enterpriseId=5d679436603d5c1746555589&role=1
        if(!enterpriseId)
            enterpriseId = baseUrlApis.getQueryVariable("enterpriseId");
        if(!role)
            role = baseUrlApis.getQueryVariable("role");
        if(role !== void 0 && role !== null){
            return store.userStore.updateRoleInfo(role, enterpriseId);
        }
        if(token){
            const info = this.getRoleInfoFromLocal(token)
            
            if(!info){
                return;
            }
            
            return store.userStore.updateRoleInfo(info.type, info.enterpriseId);
        }
    }

    getEnterpriseUserPermission = (enterpriseId, callback)=>{
        return loginApis.getEnterpriseUserPermission(enterpriseId).then((result)=>{
            callback && callback(result);
            return result;
        });
    }

    getRememberMe = (casTicket, isCheck)=>{
      if(isCheck === true || isCheck == 1) {
        return true;
      }
      // checked: ST-4-SUTFefDFf5lXtNQTYDY4-smx-1; no: ST-4-SUTFefDFf5lXtNQTYDY4-smx
      isCheck = baseUrlApis.getQueryVariable("remember_me") === "1";
      !isCheck && (isCheck = casTicket && casTicket.match(/-1$/g));
      return !!isCheck;
    }

    checkRememberMe = (isCheck)=>{
      // checked: ST-4-SUTFefDFf5lXtNQTYDY4-smx-1; no: ST-4-SUTFefDFf5lXtNQTYDY4-smx
      if (isCheck) {
        storageSetItem(localStorage, "remember-me", "1");
        return;
      }
      storageRemoveItem(localStorage, "remember-me");
    }
    reLoadUserApisForServiceWorker = async ()=>{
      const {token, roleInfo, hasSignIn} = store.userStore;
      if(!hasSignIn){
        return;
      }
      const { ret } = await this.getUserInfo(token);
      if(ret === 0){
        appStoreCloudApis.doCheckEdu()
        if(roleInfo){
          const {enterpriseId} = roleInfo;
          this.getEnterpriseUserPermission(enterpriseId);

          return;
        }

        await appStoreCloudApis.getPhantomOnlineSub();

        const {isActive} = store.accountStore;

        if (!isActive) {
          this.checkDashboardPermission();
        }
      }
    }
    preloadUserDetails = (token, enterpriseId, role)=>{
        store.userStore.setTokenCache(token);
        // is not enterprise user
        const __enterpriseId = this.getEnterpriseId(token, enterpriseId)

        if(!__enterpriseId){
          store.accountStore.preloadAccountDetails();
        }else {
          store.userStore.updateRoleInfo(role, __enterpriseId);
        }
        // let handle = setTimeout(()=>{
        //   clearTimeout(handle)
        // }, 0);
    }
    reduceDisturbForCommonDomainUser(userInfo) {
        if (!userInfo || (userInfo.region !== 'eu' && userInfo.region !== 'ca')) {
            return
        }

        const storageKey = 'euUserList'
        const { userEmail, region } = userInfo
        let euUserList = storageGetItem(localStorage, storageKey)
        let userEnvOnlineUrl

        if (region === 'eu') {
            userEnvOnlineUrl = store.userStore.getOnlineEUUrl(region)
        }
        if (region === 'ca') {
            userEnvOnlineUrl = store.userStore.getOnlineCAUrl(region)
        }

        if (!euUserList) {
            euUserList = [userInfo.userEmail]
            storageSetItem(localStorage, storageKey, JSON.stringify(euUserList))
            
            return
        }
        
        euUserList = JSON.parse(euUserList)
        
        const isInEuUserList = euUserList.some(function (item) {
            if (userEmail === item) {
                return true
            }
        })
        
        if (isInEuUserList) {
            store.userStore.goToTargetInstance(userEnvOnlineUrl, true)

            return true
        }

        euUserList.push(userEmail)
        storageSetItem(localStorage, storageKey, JSON.stringify(euUserList))
    }
    checkTokenAndInitUserInfo = async (token, enterpriseId, role, keepCookie) =>{
        enterpriseId = enterpriseId || getQueryVariable('enterpriseId')

        const { ret, info } = await this.getUserInfo(token, enterpriseId);

        // this.preloadUserDetails(token, enterpriseId, info.enterpriseRole);

        if(store.appStore.isOnPremiseDeployMode){
            store.userStore.setIntervalCheckToken(token)
        }
        if(ret === 0){
            store.userStore.updateToken(token, keepCookie);
            
            // must be use 'await' to keep 'emit USER_SIGN_IN_SUCCESS' after 'updateUserInfo'
            //await store.userStore.updateUserInfo(info);
            this.onCheckUserEmailType();
            await Promise.all([store.userStore.updateUserInfo(info)]);
            this.checkRole(token, enterpriseId, role);
            store.appStore.doNoticeMessage(USER_SIGN_IN_SUCCESS);
            return {ret:0, token};
        }

        store.userStore.cleanTokenCache();
        if(ret === 210007){
            // You haven't log on yet or your session has time out, please log on again.
            //store.historyStore.push({pathname:''})
            return {ret, token};
        }

        return {ret: 110001, token:""};
    }
    // updateUserInfo = ({ params, success, fail }) => {
    //     serverConfigApi.updateUserInfo({ params, success, fail })
    // }

    /**
     * can be used to check whether the token is valid
     *
     * @memberof UserService
     */
    getUserInfo = async (token, enterpriseId) =>{
        try {
            let info = await loginApis.getUserInfo(token, enterpriseId);
            return { info, ret:0 };
        } catch (error) {
            //
            console.error("TCL: UserService -> getUserInfo -> error", error);
            if(error && error.ret ){
                return { info:error, ret:error.ret };
            }
            return { info:error, ret:-1 };
        }
    }

    getUserJWT = (token, from)=>{
        return loginApis.getUserJWT(token, from);
    }

    getTicket = (params, callback)=>{
        loginApis.getTicket(params).then((data)=>{

            callback && callback(data);
        }).catch((/* err */)=>{
            callback && callback("");
        });
    }

    modifyPassword = ({old_password, new_password,token}, callback)=>{
        loginApis.modifyPassword({old_password, new_password}, token).then((data)=>{
            callback && callback(data);
        });
    }

    updateUserInfo = ({ first_name, last_name, bUsedPPO, phone }, callback) =>{
        loginApis.updateUserInfo({ first_name, last_name, bUsedPPO, phone }).then((result)=>{
            callback && callback(result);
        });
    }
    doMockUser(callback){
        import (/* webpackChunkName: "users.mock" */"@/__mock__/users/index.js").then(({user})=>{

            // let map = {
            //     user:user,
            // }

            callback && callback(user);

        }).catch((err)=>{
            console.error("TCL: doMockSubscribe -> err", err);

        });
    }
    doLoginByApi = ({ email, userMobile, password })=>{
        return loginApis.loginByApi({email, userMobile, password})
    }
    checkDashboardPermission =(callback, error)=>{
        return platformApis.checkDashboardPermission().then((result) => {
            if(result && result.ret === 0){
                callback && callback(result);
                return;
            }
            error && error(result);
        }).catch((err)=>{
            error && error(err);
        });
    }

    updateUserNotify = ({ userNotifyType, userNotifyStatus }, callback) =>{
        loginApis.updateUserNotify({ userNotifyType, userNotifyStatus }).then((result)=>{
            callback && callback(result);
        });
    }
    getSurveyNPS = ()=>{
        return loginApis.getSurveyNPS()
    }
    updateSurveyNPS = (params)=>{
        return loginApis.updateSurveyNPS(params);
    }
    async getRequestCode({codeID}, successCallback, errorCallback){
        try {
            let result = await loginApis.getRequestCode({codeID});
            if (result && result.ret === 0) {
                return successCallback && successCallback(result)
            }
            errorCallback && errorCallback(result);
        } catch (error) {
            errorCallback && errorCallback(error);
        }
    }

    checkAccountExist = (account,  isMobile = true, callback = undefined) =>{
        return loginApis.checkAccountExist(account, isMobile).then((result)=>{
            callback && callback(result);
            return result;
        });
    }

    sendVerificationCode = (account, isMobile = true, callback = undefined) =>{
        return loginApis.sendVerificationCode(account, isMobile).then((result)=>{
            callback && callback(result);
            return result;
        });
    }

    setAccount = (account, code, isMobile = true, callback = undefined) =>{
        return loginApis.setAccount(account, code, isMobile).then((result)=>{
            callback && callback(result);
            return result;
        });
    }
}
export default UserService;
